/**
 * Shared tRPC React client
 *
 * Single instance of createTRPCReact to be used by the host app and all verticals.
 * This ensures all components share the same React Query cache and tRPC context.
 *
 * AppRouter is a type-only import. Do not import ./routers as a value from this
 * file: that graph includes auth/server and pg, which must stay off the browser bundle.
 */
import { createTRPCReact, type CreateTRPCReact } from '@trpc/react-query';
import type { AppRouter } from './routers';

export const trpc: CreateTRPCReact<AppRouter, unknown> = createTRPCReact<AppRouter>();
